(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9351],{

/***/ 52272:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hoat-dong-noi-bat-cua-lanh-dao/[...slug]",
      function () {
        return __webpack_require__(61760);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 61760:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _common_hoc_ClientPage_index__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(81346);
/* harmony import */ var _common_utility_asyncComponent__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31691);




var DetailActivity = (0,_common_utility_asyncComponent__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function() {
    return Promise.all(/* import() */[__webpack_require__.e(1170), __webpack_require__.e(2879), __webpack_require__.e(3051), __webpack_require__.e(1477)]).then(__webpack_require__.bind(__webpack_require__, 91477));
}, true);
/* harmony default export */ __webpack_exports__["default"] = ((0,_common_hoc_ClientPage_index__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DetailActivity, {});
}));


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1228,4617,3874,4614,3376,1346,9774,2888,179], function() { return __webpack_exec__(52272); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);